module.exports = __webpack_public_path__ + "img/fileIconOrange.dd076d82.png";